export default __webpack_public_path__ + "static/media/5_1_1.d3f97103.png";